var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    stroke: "#F1935C",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8238 9.57702V15.625C17.8098 16.0206 17.7176 16.4095 17.5526 16.7693C17.3876 17.1291 17.153 17.4527 16.8624 17.7215C16.5715 17.9915 16.2303 18.2015 15.8582 18.3396C15.4862 18.4776 15.0905 18.5411 14.6939 18.5262H9.33629C8.93728 18.5444 8.5386 18.4837 8.16309 18.3476C7.78759 18.2114 7.44265 18.0025 7.14805 17.7328C6.8546 17.4633 6.61761 17.1382 6.45087 16.7764C6.28413 16.4145 6.19095 16.0232 6.17676 15.625V8.37278C6.19077 7.97719 6.28294 7.58827 6.44794 7.22846C6.61295 6.86865 6.84753 6.54505 7.13817 6.27631C7.42905 6.00633 7.77027 5.7963 8.14235 5.65822C8.51442 5.52015 8.91005 5.45673 9.30664 5.4716H13.3401C13.9558 5.46943 14.5501 5.69725 15.0066 6.11043L17.0961 8.03184C17.319 8.22389 17.499 8.46073 17.6244 8.72695C17.7498 8.99317 17.8177 9.28281 17.8238 9.57702Z",
    fill: "#F1935C",
    stroke: "#F1935C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9402V15.7218",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1926 13.9422L12.3114 15.8233C12.2707 15.8645 12.2222 15.8972 12.1688 15.9196C12.1153 15.9419 12.058 15.9534 12.0001 15.9534C11.9422 15.9534 11.8848 15.9419 11.8314 15.9196C11.778 15.8972 11.7295 15.8645 11.6888 15.8233L9.80762 13.9415",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5439 5.47266V8.01101C13.5439 8.35477 13.6809 8.68513 13.9251 8.92866C14.17 9.17245 14.5015 9.30926 14.847 9.30913H17.7588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOrange);
export default __webpack_public_path__ + "static/media/downloadOrange.e37e51a0e9709dbc976e2adff5347241.svg";
export { ForwardRef as ReactComponent };